import React, { useEffect, useState } from "react";
import { usePreventWheelChange } from "../../utils/usePreventWheelChange";
import Button, { ButtonType } from "../Assets/Button";

interface EditPriceListModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (price: number, margin: number) => void;
  initialPrice?: number;
  initalMargin?: number;
  title: string;
}

const EditPriceListModal: React.FC<EditPriceListModalProps> = ({
  open,
  onClose,
  onSave,
  initialPrice,
  initalMargin,
  title,
}) => {
  const [price, setPrice] = useState(initialPrice || 0);
  const [margin, setMargin] = useState(initalMargin || 0);

  const handleWheelPrevent = usePreventWheelChange();

  useEffect(() => {
    if (open) {
      setPrice(initialPrice ?? 0);
      setMargin(initalMargin ?? 0);
    }
  }, [initalMargin, initialPrice, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 animate-in fade-in zoom-in-95">
        {/* Header */}
        <div className="mb-5">
          <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
          <p className="text-sm text-gray-500 mt-1">
            Update pricing details below
          </p>
        </div>

        {/* Price */}
        <div className="mb-4">
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Price
          </label>
          <input
            type="number"
            value={price}
            onWheel={handleWheelPrevent}
            onChange={(e) => setPrice(Number(e.target.value))}
            className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm 
                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                       transition-all duration-200"
            placeholder="Enter price"
          />
        </div>

        {/* Margin */}
        <div className="mb-6">
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Margin (%)
          </label>
          <input
            type="number"
            value={margin}
            onWheel={handleWheelPrevent}
            onChange={(e) => setMargin(Number(e.target.value))}
            className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm 
                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                       transition-all duration-200"
            placeholder="Enter margin"
          />
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-sm px-4 py-2"
          >
            Cancel
          </Button>

          <Button
            type={ButtonType.Submit}
            onClick={() => onSave(price, margin)}
            className="text-sm px-4 py-2"
          >
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditPriceListModal;
